import TrendsMobileTabs from "./TrendsMobileModules/TrendsMobileTabs";


const TrendsMobile = () => {
  return (
    <>
      <TrendsMobileTabs />
    </>
  );
};

export default TrendsMobile;
